<!--
  - Copyright (c) 2021. Catch Bangladesh / BitFlex. All rights reserved.
  -->

<template>

    <div class="lg:px-20 px-2 mt-8 mb-8">
            <span class="text-primary font-bold text-2xl mt-8">
                PRIVACY POLICY
            </span>
            <br>
            <br>
            <span class="text-primary  text-lg mt-8">
                Welcome to AstharProtik.
            </span>
            <br>
            <br>

            AstharProtik (“us”, “we”, or “our”) operates astharprotik.shop which is a sister concern of Catch Bangladesh.
            <br>
            <br>
            Our Privacy Policy governs your visit to astharprotik.shop and explains how we collect, safeguard, and disclose information that
            results from your use of our Service. We don’t collect your personal information without letting you know.
            <br>
            <br>
            We use your data to provide and improve Service. By using Service, you agree to the collection and use of information in
            accordance with this policy. Unless defined in this Privacy Policy, the terms used in here have the same meanings as in our
            Terms and Conditions.
            <br>
            <br>
            Our Terms and Conditions (“Terms”) govern all use of our Service and together with the Privacy Policy constitutes your
            agreement with us (“Agreement”). Individual information is a living person who can be identified from that information
            (or from those and other data either in our ownership or prone to come into our ownership). Usage of data gathered
            naturally either created by the utilization of administration (for instance, the length of a page visit).
            Cookies are small files stored on your device (computer or mobile device).
            <br>
            <br>

            <span class="text-primary font-bold text-2xl mt-8">
                Information Collection and Use
            </span>
            <br>
            <br>
                We gather a few distinct kinds of data for different purposes and to improve our service to you.
                While having our service, we may request that you give us some recognizable data that can be utilized to
            contact or isolate you. Recognizable data may include, yet isn't restricted to:
            <br>
            <span class="text-primary text-xl ml-6">1.</span> Email address
            <br>
            <span class="text-primary text-xl ml-6">2.</span> First name and last name
            <br>
            <span class="text-primary text-xl ml-6">3.</span> Phone number
            <br>
            <span class="text-primary text-xl ml-6">4.</span> Address, Country, State, Province, ZIP/Postal code, City
             <br>
            <span class="text-primary text-xl ml-6">5.</span> Cookies and Usage Data

            <br>
            We may use your Personal Data to contact you with newsletters, marketing or promotional materials, and
            other information that may be of interest to you. You may also receive mail about new features, campaigns,
            app updates, etc.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl mt-8">
                Other Data
            </span>
            <br>
            <br>
                While utilizing our service, we may likewise gather the accompanying data: sex, age, place of birth, date of birth, visa subtleties, citizenship, enlistment at the place of residence and genuine location, phone number (work, versatile), educational qualification, capability, proficient training, business arrangements, data on marital status, relatives, NID number, Passport number, Identification number (or other citizen ID), office address, and other information. AstharProtik utilizes this gathered information for different purposes like;
            <br>

            <span class="text-primary text-xl ml-6">1.</span> To provide and maintain our Service;
                <br>

            <span class="text-primary text-xl ml-6">2.</span> To notify you about changes to our Service;
            <br>

            <span class="text-primary text-xl ml-6">3.</span> Allowing you to participate in interactive features of our services when you opt to do so;
            <br>
            <span class="text-primary text-xl ml-6">4.</span> Providing customer support;
            <br>
            <span class="text-primary text-xl ml-6">5.</span> Accumulate analysis or valuable information so that we can improve our services
              <br>

            <span class="text-primary text-xl ml-6">6.</span>Monitor the usage of our Service;
            <br>
            <span class="text-primary text-xl ml-6">7.</span> To detect, prevent and address technical issues;
             <br>

            <span class="text-primary text-xl ml-6">8.</span> To carry out our obligations and enforce our rights arising from any contracts entered into between you and us, including for billing and collection;
              <br>

            <span class="text-primary text-xl ml-6">9.</span>To provide notices about your account and subscription, including expiration and renewal notices, email-instructions, etc.;
             <br>

            <span class="text-primary text-xl ml-6">10.</span> To provide you with news, special offers, and general information about other goods, services; events which we offer that are similar to those that you have already purchased or enquired about unless you have opted not to receive such information;
            <br>
            <span class="text-primary text-xl ml-6">11.</span> In any other way we may describe when you provide the information;
                <br>

            <span class="text-primary text-xl ml-6">12.</span> For any other purpose with your consent.

            <br>
            <br>

            <span class="text-primary font-bold text-2xl ">Transfer of Data
                </span>
            <br>
            <br>
              Your data, including personal data, might be handed to – and kept up on outside of your state,
            territory, nation, or other legislative wards where the information security laws may vary from those of your locale.
            If your location is outside Bangladesh and decides to give data to us, kindly note that we transfer the information,
            including Individual Information, to Bangladesh and process it there. You agree to this privacy policy followed by the
            submission of such data speaks to your consent to that transfer. AstharProtik will make all the sensible steps necessary
            to guarantee that your information is dealt with safely and as per this Protection Strategy and no exchange of your
            Information will occur to an association or a nation except if there are satisfactory controls set up including the
            security of your information and other personal data. We may reveal individual data that we collect, or give. In specific
            situations, we might be needed to disclose your own information whenever needed to do as such by law or because of
            legitimate solicitations by public authorities.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl ">
                Business Transaction.
            </span>
            <br>
            <br>
                Please note, if you ask us to delete, it may impact your experience with us, and you may not be able to participate
            in certain programs or membership services that require the usage of your personal information to function. But in no
            circumstances, we will discriminate against you for exercising your rights. We may provide paid items as well as services
            within service. All things considered, we use third-party payment processors. We don't store or gather your installment
            card subtleties. That data is given legitimately to our outsider installment processors whose utilization of your own data
            is administered by their Protection Strategy.
            <br>
            <br>
                1. To delete your own data as a user, you can deactivate or delete all of your personal data and delete your
            profile once and for all. On the other hand as a shop owner which is listed in the database; you will not be able to
            access this feature easily. You have to let us know via email about deleting their data with proper grounds. And if a
            shop doesn't want to continue with our service, they have to let AstharProtik authority know about this. Later on, Catch
            Mart will take action based on proper information and evaluating the scenario in the right manner.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl ">
                Service Providers
            </span>
            <br>
            <br>
                We may use third-party organizations and people to provide our service ("Service Providers"),
            offer support for our sake, perform service-related tasks, or help us in examining how our service is utilized.
            These outsiders approach your information just to play out given roles for our benefit and are committed not to
            disclose or utilize it for some other reason.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl ">
                Advertising
            </span>
            <br>
            <br>
                We may use third-party ad providers to help uphold and keep up our services.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl ">
                Changes to This Privacy Policy
            </span>
            <br>
            <br>
                To provide a user-friendly service we may update our privacy policy from time to time. We will notify you
            of any progressions by posting the new privacy policy on this page. We will inform you through email or potentially
            an unmistakable notification on our service, preceding the change getting powerful and update "successful date" at
            the head of this Security Strategy. You are encouraged to go through this privacy policy occasionally for any changes.
            Changes to this privacy policy are effective when they are posted on this page.
            <br>
            <br>
            <span class="text-primary font-bold text-2xl ">

                Contact Us
            </span>
            <br>
            <br>
                If you have any questions about this Privacy Policy, please contact us by email: astharprotik@gmail.com.
            <br>
            <br>
                (This Privacy Policy was created and can be updated with new rules only by AstharProtik)
    </div>

</template>

<script>
export default {
    name: "privacyPolicy"
}
</script>

<style scoped>

</style>
